import React from 'react';
import { OfficeExclusiveUpload } from '@brightmls/nextgen.lae.mediacenter';
import OfficeExclusiveWrapper from './OfficeExclusiveWrapper';

export const OfficeExclusiveUploadField = () => {
  return (
    <OfficeExclusiveWrapper>
      <OfficeExclusiveUpload description="This document will not be shared outside this listing" />
    </OfficeExclusiveWrapper>
  );
};

export default OfficeExclusiveUploadField;
